//=================================================
//    summary: DCP Email驗證視窗 EmailVerified -- Hook
//
//    remarks: 000 Tim 2021/11/08 Create
//================================================
import React, { useState, useEffect } from 'react'
import cssEmailVerified from './EmailVerified.module.scss'
import {GlobalLibs, NetworkLibs, PackageVariablesLibs} from 'bc-react-package'

// #region Member Variables
let mblnInitialized = false

let mstrEmailPlaceHolder = ""
let mblnInputDisabled = false
let mobjCallParam = null
// #endregion Member Variables


const COMP_NAME = "EmailVerified"

function EmailVerified(props)
{
    console.log(COMP_NAME + ".Begin: ", props)

    // #region Init State
    const [email, setEmail] = useState("")
    // #endregion Init State

    // #region First Launch
    if (!mblnInitialized)
    {
        console.log(COMP_NAME + " Init variable")

        mblnInitialized = true

        if (
            (typeof (window.gSession.Acc.Profile) !== 'undefined') &&
            (window.gSession.Acc.Profile !== null) &&
            (typeof (window.gSession.Acc.Profile.Email) !== 'undefined') &&
            (window.gSession.Acc.Profile.Email !== null) &&
            (window.gSession.Acc.Profile.Email !== '')
            )
        {
            mstrEmailPlaceHolder = window.gSession.Acc.Profile.Email
            mblnInputDisabled = true
        }
        else
        {
            mstrEmailPlaceHolder = window.gAppUI.LBL_EmailPlaceHolder
            mblnInputDisabled = false
        }

        console.log(COMP_NAME + ".Begin: mblnInitialized: ", mblnInitialized)    
    } // end of if (!mblnInitialized)
    // #endregion First Launch

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        console.log(COMP_NAME + ".useEffect")

        // Similar to componentWillUnmount
        return () => {
            console.log(COMP_NAME + ".cleanup")
            
            mblnInitialized = false
        }
    }, [])


    // #region OnTapHandler
    /*===========================================
    summary: 點選 關閉
    remarks: 000 Tim 2021/11/04 Create
    ===========================================*/
    function CloseOnTapHandler()
    {
        console.log(COMP_NAME + ".CloseOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }
        
        let objCallbackData = {
            "Action": "CloseShowEmailVerified"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseOnTapHandler

    /*===========================================
    summary: 點選 立即驗證
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function VerifyNowOnTapHandler(StateEmail)
    {
        console.log(COMP_NAME + ".VerifyNowOnTapHandler: ")
        // 按下後，延遲一下再切換，解決雙擊可能會進入雙層的問題   Tim15.07.31
        if (GlobalLibs.IsClickTooFast())
        {
            return
        }

        // if (
        //     (typeof(props.CallbackRef) !== 'undefined') &&
        //     (props.CallbackRef !== null)
        //     )
        // {
        //     let objCallbackData = {
        //         "Action": "VerifyNowOnTap"
        //     }
        //     props.CallbackRef(objCallbackData)
        // }

        let strEmail = ""
        if (mstrEmailPlaceHolder !== window.gAppUI.LBL_EmailPlaceHolder)
        {
            strEmail = window.gSession.Acc.Profile.Email
        }
        else
        {
            strEmail = StateEmail
        }

        mobjCallParam = {
            "AccountID": window.gSession.Acc.ID,
            "EmailAddr": strEmail,                              // window.gSession.Acc.Profile.Email // "jeff.lin@betterchinese.com"
            "LoginName": window.gSession.Acc.LoginName,         // window.gSession.Acc.LoginName // "jeff.lin@betterchinese.com"
            "SysType": window.gSession.App.SysType
        }

        SendAccountVerifyEmail()
    } // end of VerifyNowOnTapHandler
    // #endregion OnTapHandler

    // #region Other Handler
    /*===========================================
    summary: 輸入框 鍵盤離開事件
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function InputKeyUpHandler(event)
    {
        console.log(COMP_NAME + ".InputKeyUpHandler: ", event)

        if (event.keyCode === 13)
        {
            event.preventDefault()
            event.target.blur() // 避免彈出帳密錯誤的Alert Message時 使用者又再按Enter 再次觸發此事件
            
            // LoginWithAccPwd(mstrClassName, mstrUserName, mstrPassword)
        } // end of if (e.keyCode === 13)
    } // end of InputKeyUpHandler

    /*===========================================
    summary: Email 改變 事件
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function EmailChangeHandler(e)
    {
        console.log(COMP_NAME + ".EmailChangeHandler: ", e)
        setEmail(e.target.value)
    } // end of EmailChangeHandler
    // #endregion Other Handler

    // #region LoadingMask and Alert Functions
    /*===========================================
    summary: 開啟 讀取中 效果
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function OpenLoadingMask(LoadingMsg)
    {
        console.log(COMP_NAME + ".OpenLoadingMask")

        let objCallbackData = {
            "Action": "OpenLoadingMask",
            "Message": LoadingMsg
        }
        props.CallbackRef(objCallbackData)
    } // end of OpenLoadingMask

    /*===========================================
    summary: 關閉 讀取中 效果
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function CloseLoadingMask()
    {
        console.log(COMP_NAME + ".CloseLoadingMask")

        let objCallbackData = {
            "Action": "CloseLoadingMask"
        }
        props.CallbackRef(objCallbackData)
    } // end of CloseLoadingMask

    /*===========================================
    summary: 顯示 提示視窗
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function ShowAlert(AlertObject)
    {
        let objCallbackData = {
            "Action": "ShowAlertWindow",
            "AlertObject": AlertObject
        }
        props.CallbackRef(objCallbackData)
    } // end of ShowAlert
    // #endregion LoadingMask and Alert Functions

    // #region AlertCallback
    /*===========================================
    summary: 送出 Email 成功 提示 Callback
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function SentEmailSuccessAlertCallback()
    {
        let objCallbackData = {
            "Action": "CloseShowEmailVerified"
        }
        props.CallbackRef(objCallbackData)
    } // end of SentEmailSuccessAlertCallback
    // #endregion AlertCallback

    // #region Web Service After Process
    /*===========================================
    summary: 送出 帳號認證 Email 後 的 流程
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function SendAccountVerifyEmailAfterProcess ()
    {   
        console.log(COMP_NAME + ".SendAccountVerifyEmailAfterProcess: ")
        
        // 跳出寄送完成的訊息
        let objAlertObject = {
            Header: null,
            Body: window.gAppUI.LBL_SentVerifySuccessed,
            ShowCloseButton: false,
            CallbackRef: SentEmailSuccessAlertCallback,
            Buttons: [
                {
                    Text: PackageVariablesLibs.UISettings.BTN_OK,
                    AutoFocus: true
                }
            ]
        }
        ShowAlert(objAlertObject)

        mobjCallParam = null
    } // end of SendAccountVerifyEmailAfterProcess
    // #endregion Web Service After Process

    // #region Web Service
    /*===========================================
    summary: 送出 帳號認證 Email
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function SendAccountVerifyEmail ()
    {
        let objRetryFuncRef = SendAccountVerifyEmail
        if (!window.navigator.onLine)
        {
            GlobalLibs.OkErrorHandler(window.gAppUI.ERR_InternetRequired_Title, window.gAppUI.ERR_InternetRequired_Msg, objRetryFuncRef)
        }
        else
        {
            let objCallbackFuncRef = SendAccountVerifyEmailCallback
            // let intWSServerType = NetworkLibs.WSServerTypeEnum.WS_WEB_GATEWAY

            // Open Loading mask with message
            OpenLoadingMask(window.gAppUI.MSG_LoadMask_SendAccountVerifyEmail)

            let objCallData = {
                "Func": "SendAccountVerifyEmail",
                "AccountID": mobjCallParam.AccountID,
                "EmailAddr": mobjCallParam.EmailAddr,
                "LoginName": mobjCallParam.LoginName,
                "SysType": mobjCallParam.SysType
            }

            NetworkLibs.WebServiceCall(objCallData, objRetryFuncRef)
                .then(Response => {
                    objCallbackFuncRef(Response)
                })
        }
    } // end of SendAccountVerifyEmail

    /*===========================================
    summary: 送出 帳號認證 Email Callback
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function SendAccountVerifyEmailCallback (Return)
    {
        // Close Loading mask        
        CloseLoadingMask()

        // you need to customize these
        let intDefaultErrNo = window.gAppUI.ERR_SendAccountVerifyEmail_No
        let strErrorTitle = window.gAppUI.ERR_SendAccountVerifyEmail_Title
        let strErrMsg = window.gAppUI.ERR_SendAccountVerifyEmail_Msg
        // end of customize

        if (Return.ErrNo !== NetworkLibs.NetworkLibErrorEnum.WS_SYNC_CALL_ERR_NO_SUCCESS)
        {
            switch (Return.CalledErrNo)
            {
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_EXIST_EMAIL_WITH_OTHER_ACCOUNTID: // -140186,  // 你輸入的信箱已存在 158
                    strErrMsg = window.gAppUI.ERR_VEExistEmailWithOtherAccountID_Msg
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_NOT_YET_CLICK_VERIFY_LINK: // -140171,  // 再次寄送認證信到你的信箱 153
                    strErrMsg = window.gAppUI.ERR_VENotYetClickVerifyLink_Msg
                    GlobalLibs.OkErrorHandler(strErrorTitle, strErrMsg)
                    break
                case window.gConst.WEB_GATEWAY_RETURN_ERR_VE_ALREADY_VERIFIED: // -140172,  // 此連結已驗證過 154
                    strErrMsg = window.gAppUI.ERR_VEAlreadyVerified_Msg
                    GlobalLibs.OkErrorHandler(strErrorTitle, strErrMsg)
                    break
                default:
                    NetworkLibs.WSCallbackErrorHandler(Return.ErrNo, Return.CalledErrNo, Return.CalledErrMsg, intDefaultErrNo, strErrorTitle, strErrMsg)
                    break
            }

            console.log("SendAccountVerifyEmailCallback: ErrNo: ", Return.ErrNo)
            console.log("SendAccountVerifyEmailCallback: CalledErrNo: ", Return.CalledErrNo)
        }
        else
        {
            console.log("SendAccountVerifyEmailCallback Return.Data: ", Return.Data)

            SendAccountVerifyEmailAfterProcess()
        }
    } // end of SendAccountVerifyEmailCallback
    // #endregion Web Service

    // #region Render元件
    /*===========================================
    summary: Verify Now Button 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentVerifyNowButton()
    {   
        return(
            <div className={cssEmailVerified.btnVerifyNow} onClick={() => VerifyNowOnTapHandler(email)}>
                {window.gAppUI.BTN_VerifyNow}
            </div>
        )
    } // end of ComponentVerifyNowButton
                            
    /*===========================================
    summary: Message 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentMessage()
    {   
        return(
            <div className={cssEmailVerified.divMessage}>
                {window.gAppUI.LBL_EmailVerifiedMsg}
            </div>
        )
    } // end of ComponentMessage

    /*===========================================
    summary: Close Button 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentCloseButton()
    {   
        return(
            <div className={cssEmailVerified.btnClose} onClick={() => CloseOnTapHandler()}/>
        )
    } // end of ComponentCloseButton

    /*===========================================
    summary: Title 顯示Component  
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function ComponentTitle()
    {   
        return(
            <div className={cssEmailVerified.divTitle}>
                {window.gAppUI.LBL_EmailVerifiedTitle}
            </div>
        )
    } // end of ComponentTitle                
    // #endregion Render元件

    // #region Render
    /*===========================================
    summary: Input Email 顯示
    remarks: 000 Tim 2021/12/21 Create
    ===========================================*/
    function RenderInputEmailWrapper(StateEmail) 
    {
        return(
            <div className={cssEmailVerified.divInput} onKeyUp={(event) => InputKeyUpHandler(event)}>
                <label htmlFor="txtEmail" className={cssEmailVerified.divHidden}>
                    {window.gAppUI.LBL_EmailPlaceHolder}
                </label>
                <input
                    id="txtEmail"
                    className={cssEmailVerified.txtInput}
                    type="email"
                    value={StateEmail}
                    placeholder={mstrEmailPlaceHolder}
                    onChange={(event) => EmailChangeHandler(event)}
                    required
                    autoComplete="true" 
                    disabled={mblnInputDisabled}/>
            </div>
        )
    } // end of RenderInputEmailWrapper

    /*===========================================
    summary: Render TopTool 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderTopToolWrapper()
    {
        return (
            <div className={cssEmailVerified.divTopTool}>
                <ComponentTitle />
                <ComponentCloseButton />
            </div>
        )
    } // end of RenderTopToolWrapper

    /*===========================================
    summary: Render Content 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderContentWrapper()
    {
        return (
            <div className={cssEmailVerified.divContent}>
                {RenderTopToolWrapper()}

                <ComponentMessage />

                {RenderInputEmailWrapper(email)}
                
                <ComponentVerifyNowButton />
            </div>
        )
    } // end of RenderContentWrapper

    /*===========================================
    summary: Render 主畫面 的顯示
    remarks: 000 Tim 2021/11/08 Create
    ===========================================*/
    function RenderMainWrapper()
    {
        return (
            <div className={cssEmailVerified.divMask}>
                <div className={cssEmailVerified.divMain}>
                    {RenderContentWrapper()}
                </div>
            </div>
        )
    } // end of RenderMainWrapper

    // Similar to Render
    return (
        <>
            {RenderMainWrapper()}
        </>
    )
    // #endregion Render
}
export default EmailVerified